// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vjle","toggleWrap":"styles_toggleWrap__MUB8X","content":"styles_content__2zazE","selectAreaCode":"styles_selectAreaCode__1fPJ6"};